import { render } from "./ConfiguratorDetails.vue?vue&type=template&id=5e4f9b66"
import script from "./ConfiguratorDetails.vue?vue&type=script&lang=js"
export * from "./ConfiguratorDetails.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__